import React from 'react';
import { transformHTMLParserLinks } from '../../../../../utils/rewriteLink/rewriteLink';
import './Disclosures.css';
import { usePageProperties } from '../../../providers/PagePropertiesProvider';

/**
 * Named after the field in the author dialogue it most tightly corresponds to
 * 
 * `disclaimerMobile` and `disclaimerMobileSecondary` also exist but can be removed from author
 * because the copy will not be different
 */
export default function Disclosures() {

    const { disclaimerDesktop, disclaimerDesktopSecondary } = usePageProperties();

    return (
        <>
            <div className='PqDataEntryForm__main--disclaimer Pqde-Disclosures__main--disclaimer'>
                {disclaimerDesktop && transformHTMLParserLinks(disclaimerDesktop)}
            </div>
            <p className='Pqde-Disclosures__helper'>
                {disclaimerDesktopSecondary && transformHTMLParserLinks(disclaimerDesktopSecondary)}
            </p>
        </>
    );
}
